import * as types from './action-types';
import * as endpoints from '../helpers/endpoints';
import searchFormat from '../helpers/search';
import apiRequest from '../helpers/apiRequest';
import { actions } from 'react-redux-form';
import moment from 'moment/moment';

export const toggleModalReporting = () => ({
    type: types.TOGGLE_MODAL_REPORTING
});

export const toggleGenerateModalReporting = () => ({
    type: types.TOGGLE_MODAL_GENERATE_REPORTING
});

export const toggleReportingFilters = loading => ({
    type: types.TOGGLE_REPORTING_FILTERS,
    loading
});

export const fetchReportingDataSuccess = payload => ({
    type: types.FETCH_REPORTING_DATA_SUCCESS,
    payload
});

export const reportingLoading = () => ({
    type: types.REPORTING_LOADING
});

export const fetchReportingDataThunk = (onload = false) => (
    dispatch,
    getState
) => {
    let billetLocation = getState().data.userInfo.Billet.location;
    let reportingFilters = getState().reportingFilters;
    let filters = '';
    const rssOssCode = reportingFilters.rssOssCode.split('-')[0];

    dispatch(reportingLoading());

    if (reportingFilters.startDate) {
        filters += `&filters[Event][startDate][gte]=${moment(
            reportingFilters.startDate
        ).format('YYYY-MM-DD')}`;
    }

    if (reportingFilters.endDate) {
        filters += `&filters[Event][startDate][lt]=${moment(
            reportingFilters.endDate
        )
            .add(1, 'days')
            .format('YYYY-MM-DD')}`;
    }

    if (reportingFilters.regionCode) {
        filters += `&filters[Event][regionCode][eq]=${
            reportingFilters.regionCode
        }`;
    }

    if (reportingFilters.districtCode) {
        filters += `&filters[Event][districtCode][eq]=${
            reportingFilters.districtCode
        }`;
    }

    if (reportingFilters.recruitingStationCode) {
        filters += `&filters[Event][recruitingStationCode][eq]=${
            reportingFilters.recruitingStationCode
        }`;
    }
    //One for RSS and OSS
    if (
        rssOssCode &&
        rssOssCode !== 'null' &&
        (billetLocation === 'RSS' || reportingFilters.rssOssType === 'RSS')
    ) {
        filters += `&filters[Event][recruitingSubStationCode][eq]=${rssOssCode}`;
    } else if (
        rssOssCode &&
        rssOssCode !== 'null' &&
        (billetLocation === 'OSS' || reportingFilters.rssOssType === 'OSS')
    ) {
        filters += `&filters[Event][ossCode][eq]=${rssOssCode}`;
    } else if (
        rssOssCode &&
        rssOssCode !== 'null' &&
        ['RS', 'District', 'Regional', 'MCRC'].includes(billetLocation)
    ) {
        let rssOrOss;
        if (reportingFilters.rssOssType === 'OSS') {
            rssOrOss = 'ossCode';
        } else {
            rssOrOss = 'recruitingSubStationCode';
        }

        filters += `&filters[Event][${rssOrOss}][eq]=${rssOssCode}`;
    }
    if (reportingFilters.category) {
        for (let i = 0; i < reportingFilters.category.length; i++) {
            filters += `&filters[Category][name][in][]=${
                reportingFilters.category[i].value
            }`;
        }
    }

    if (reportingFilters.emvAttend) {
        filters += `&filters[EventReport][emvAttend][eq]=${
            reportingFilters.emvAttend
        }`;
    }

    if (reportingFilters.fromCost) {
        filters += `&filters[Event][cost][gte]=${reportingFilters.fromCost}`;
    }

    if (reportingFilters.toCost) {
        filters += `&filters[Event][cost][lte]=${reportingFilters.toCost}`;
    }

    if (reportingFilters.estimatedTargetAttendance) {
        filters += `&filters[Event][estAttendance][eq]=${
            reportingFilters.estimatedTargetAttendance
        }`;
    }

    if (reportingFilters.leadCards) {
        filters += `&filters[EventReport][leadCards][eq]=${
            reportingFilters.leadCards
        }`;
    }

    if (filters.targetMarketRating) {
        filters += `&filters[EventReport][targetMarketRating][eq]=${
            reportingFilters.targetMarketRating
        }`;
    }

    if (reportingFilters.comingOfAgeRating) {
        filters += `&filters[EventReport][comingOfAgeRating][eq]=${
            reportingFilters.comingOfAgeRating
        }`;
    }

    if (reportingFilters.influentialRating) {
        filters += `&filters[EventReport][influentialRating][eq]=${
            reportingFilters.influentialRating
        }`;
    }

    if (reportingFilters.communityRelationsRating) {
        filters += `&filters[EventReport][communityRelationsRating][eq]=${
            reportingFilters.communityRelationsRating
        }`;
    }

    if (reportingFilters.leadGenerationRating) {
        filters += `&filters[EventReport][leadGenerationRating][eq]=${
            reportingFilters.leadGenerationRating
        }`;
    }
    apiRequest(
        `${
            endpoints.EVENT_SEARCH_PATH
        }?${filters}&include[]=Parent&include[]=Children&include[]=PromoCodeStats&include[]=EventReport&fields[Category][]=name&fields[Region][]=name&fields[District][]=name&fields[RecruitingStation][]=name&fields[RecruitingSubStation][]=name&fields[OSS][]=name&filters[Event][status][notin][]=Rejected&filters[Event][status][notin]=Deleted`,
        getState().auth.jwtToken
    ).then(data => {
        dispatch(filterReportingData(data));
    });
};

export const filterReportingData = data => (dispatch, getState) => {
    let filters = getState().reportingFilters;
    let filteredData = {
        data: []
    };

    //Where we filter the results
    filteredData.data = data.data
        .filter(item => {
            //Event Status
            //Event Report Status
            let isMatch = false;

            if (
                filters.eventStatus.length === 0 &&
                filters.eventReportStatus.length === 0
            ) {
                isMatch = true;
            }

            //Event Status
            if (
                filters.hasOwnProperty('eventStatus') &&
                filters.eventStatus.length !== 0
            ) {
                if (
                    item.status === 'Incomplete' &&
                    filters.eventStatus.includes('Event Creation')
                ) {
                    isMatch = true;
                }
                if (
                    item.status === 'Unapproved' &&
                    filters.eventStatus.includes('Event Review')
                ) {
                    isMatch = true;
                }
            }

            //Event Report Status
            if (
                filters.hasOwnProperty('eventReportStatus') &&
                filters.eventReportStatus.length !== 0
            ) {
                if (item.status === 'Approved') {
                    if (
                        item.EventReport.status === 'Pending' &&
                        filters.eventReportStatus.includes(
                            'After Action Pending'
                        )
                    ) {
                        isMatch = true;
                    }

                    if (item.EventReport.status === 'Incomplete') {
                        if (
                            moment(item.startDate) > moment() &&
                            filters.eventReportStatus.includes(
                                'After Action Pending'
                            )
                        ) {
                            isMatch = true;
                        } else {
                            if (
                                filters.eventReportStatus.includes(
                                    'After Action Incomplete'
                                )
                            ) {
                                isMatch = true;
                            }
                        }
                    }
                    if (
                        item.EventReport.status === 'Unapproved' &&
                        filters.eventReportStatus.includes(
                            'After Action Review'
                        )
                    ) {
                        isMatch = true;
                    }
                    if (
                        item.EventReport.status === 'Approved' &&
                        filters.eventReportStatus.includes(
                            'Event/After Action Closed'
                        )
                    ) {
                        isMatch = true;
                    }
                }
            }
            return isMatch;
        })
        .filter(item => {
            let isMatch = false;

            //Nothing is selected default
            if (filters.ethnicity.length === 0) {
                isMatch = true;
            }

            if (filters.ethnicity.length > 0 && item.PromoCodeStats !== null) {
                if (
                    filters.ethnicity.includes('African American') &&
                    item.PromoCodeStats.EthnicityAfricanAmerican > 0
                ) {
                    isMatch = true;
                }
                if (
                    filters.ethnicity.includes('N/A') &&
                    item.PromoCodeStats.EthnicityUnknown > 0
                ) {
                    isMatch = true;
                }
                if (
                    filters.ethnicity.includes('Other') &&
                    item.PromoCodeStats.EthnicityOther > 0
                ) {
                    isMatch = true;
                }
                if (
                    filters.ethnicity.includes('Hispanic') &&
                    item.PromoCodeStats.EthnicityHispanic > 0
                ) {
                    isMatch = true;
                }
                if (
                    filters.ethnicity.includes('Asian') &&
                    item.PromoCodeStats.EthnicityAsian > 0
                ) {
                    isMatch = true;
                }
                if (
                    filters.ethnicity.includes('Caucasian') &&
                    item.PromoCodeStats.EthnicityCaucasian > 0
                ) {
                    isMatch = true;
                }
            }
            return isMatch;
        });

    dispatch(fetchReportingDataSuccess(filteredData));
    dispatch(reportingLoading());
};

export const updateReportingDistrictSuccess = payload => ({
    type: types.UPDATE_REPORTING_DISTRICT_SUCCESS,
    payload
});

export const updateReportingRSSuccess = payload => ({
    type: types.UPDATE_REPORTING_RS_SUCCESS,
    payload
});

export const updateReportingRssOssSuccess = payload => ({
    type: types.UPDATE_REPORTING_RSS_OSS_SUCCESS,
    payload
});

export const updateReportingDistrict = e => (dispatch, getState) => {
    const region = typeof e === 'string' ? e : e.target.value;

    dispatch(actions.change('reportingFilters.districtCode', ''));
    dispatch(updateReportingDistrictSuccess([]));
    dispatch(actions.change('reportingFilters.recruitingStationCode', ''));
    dispatch(updateReportingRSSuccess([]));
    dispatch(actions.change('reportingFilters.rssOssCode', ''));
    dispatch(actions.change('reportingFilters.rssOssType', ''));
    dispatch(updateReportingRssOssSuccess([]));

    apiRequest(
        `${endpoints.LOCATION_DISTRICT_LIST}${region}`,
        getState().auth.jwtToken
    ).then(payload => {
        dispatch(updateReportingDistrictSuccess(payload.data));
    });
};

export const updateReportingRS = e => (dispatch, getState) => {
    const districtCode = typeof e === 'string' ? e : e.target.value;

    dispatch(actions.change('reportingFilters.recruitingStationCode', ''));
    dispatch(updateReportingRSSuccess([]));
    dispatch(actions.change('reportingFilters.rssOssCode', ''));
    dispatch(actions.change('reportingFilters.rssOssType', ''));
    dispatch(updateReportingRssOssSuccess([]));

    apiRequest(
        `${endpoints.LOCATION_RS_LIST}${districtCode}`,
        getState().auth.jwtToken
    ).then(payload => {
        dispatch(updateReportingRSSuccess(payload.data));
    });
};

export const updateReportingRssOss = e => (dispatch, getState) => {
    const rsCode = typeof e === 'string' ? e : e.target.value;
    const userBilletLocation = getState().data.userInfo.Billet.location;

    if (userBilletLocation === 'RSS') {
        apiRequest(
            `${endpoints.LOCATION_RSS_LIST}${rsCode}`,
            getState().auth.jwtToken
        ).then(payload => {
            dispatch(
                updateReportingRssOssSuccess(
                    searchFormat.formatOSSRSSDropdown(payload.data)
                )
            );
        });
    } else if (userBilletLocation === 'OSS') {
        apiRequest(
            `${endpoints.LOCATION_OSS_LIST}${rsCode}`,
            getState().auth.jwtToken
        ).then(payload => {
            dispatch(
                updateReportingRssOssSuccess(
                    searchFormat.formatOSSRSSDropdown(payload.data)
                )
            );
        });
    } else {
        apiRequest(
            `${endpoints.LOCATION_RSS_LIST}${rsCode}`,
            getState().auth.jwtToken
        ).then(payload => {
            let RssList = payload.data;
            apiRequest(
                `${endpoints.LOCATION_OSS_LIST}${rsCode}`,
                getState().auth.jwtToken
            ).then(payload => {
                dispatch(
                    updateReportingRssOssSuccess(
                        searchFormat.formatOSSRSSDropdown(
                            payload.data.concat(RssList)
                        )
                    )
                );
            });
        });
    }
};

export const updateReportingRSSOSSType = e => (dispatch, getState) => {
    //update here to get the right oss rss type
    const ossRssType = e.target[e.target.selectedIndex].getAttribute(
        'data-type'
    );
    dispatch(actions.change('reportingFilters.rssOssType', ossRssType));
};

export const setEventStatusReport = () => (dispatch, getState) => {
    const eventStatusReport = getState().reportingFilters.eventStatusReport;
    if (eventStatusReport.length) {
        dispatch(actions.change('reportingFilters.startDate', moment()));
        dispatch(
            actions.change('reportingFilters.endDate', moment().add(60, 'days'))
        );

        dispatch(
            actions.change('reportingFilters.eventStatus', [
                'Event Creation',
                'Event Review'
            ])
        );
        dispatch(
            actions.change('reportingFilters.eventReportStatus', [
                'After Action Pending',
                'After Action Incomplete',
                'After Action Review'
            ])
        );
    } else {
        dispatch(
            actions.change(
                'reportingFilters.startDate',
                moment().add(-60, 'days')
            )
        );
        dispatch(actions.change('reportingFilters.endDate', moment()));
        dispatch(actions.change('reportingFilters.eventStatus', []));
        dispatch(actions.change('reportingFilters.eventReportStatus', []));
    }
};

export const setReportingDateRange = () => (dispatch, getState) => {
    const startDate = getState().reportingFilters.startDate;
    const endDate = getState().reportingFilters.endDate;
    if (
        startDate.length !== 0 &&
        (endDate.length !== 0) & moment(startDate).isAfter(moment(endDate))
    ) {
        dispatch(actions.change('reportingFilters.startDate', moment(endDate)));
        dispatch(actions.change('reportingFilters.endDate', moment(startDate)));
    }
};

export const toggleFilterResetBtn = () => ({
    type: types.FILTER_BTN_ACTION
});

export const resetReportingBtn = () => dispatch => {
    //Set it true
    dispatch(toggleFilterResetBtn());
    dispatch(actions.reset('reportingFilters'));
    dispatch(actions.change('reportingFilters.emvAttend', ''));
    dispatch(actions.change('reportingFilters.category', []));
    dispatch(onLoadReportingLocations('reportingFilters'));
};

export const onLoadReportingLocations = model => (dispatch, getState) => {
    const userInfo = getState().data.userInfo;
    const regionCode = userInfo.regionCode ? userInfo.regionCode : '';
    const districtCode =
        userInfo.District !== null ? userInfo.District.code : '';
    const rsCode = userInfo.RS !== null ? userInfo.RS.code : '';
    const rssCode = userInfo.RSS !== null ? userInfo.RSS.code : '';
    const ossCode = userInfo.OSS !== null ? userInfo.OSS.ossNumber : '';
    const rssOssCode = rssCode || ossCode;
    let rssOssType = '';
    if (rssCode !== '' && rssOssCode) {
        rssOssType = '-RSS';
    } else if (ossCode !== '' && rssOssCode) {
        rssOssType = '-OSS';
    }

    dispatch(actions.change(`${model}.regionCode`, regionCode));
    dispatch(updateReportingDistrict(regionCode));
    dispatch(actions.change(`${model}.districtCode`, districtCode));
    dispatch(updateReportingRS(districtCode));
    dispatch(actions.change(`${model}.recruitingStationCode`, rsCode));
    dispatch(updateReportingRssOss(rsCode));
    dispatch(
        actions.change(`${model}.rssOssCode`, `${rssOssCode}${rssOssType}`)
    );
    dispatch(
        actions.change(`${model}.rssOssType`, rssOssType.replace('-', ''))
    );
};



// WEBPACK FOOTER //
// ./src/actions/reporting.js